/* eslint-disable */
/* global $ */
// import swal from 'sweetalert2';
import moment from 'moment-timezone'
import $ from "jquery"
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
    sha512
}
from 'js-sha512'
import is from 'is_js'
import {
    uuid
} from './mediator/eDB/util';
let config = require('../../config/config.json')[process.env.NODE_ENV];

export default (function(global) {
    if (typeof global.localStorage === 'undefined') {
        global.localStorage = {
            _storage: {},
            setItem: function(key, value) {
                this._storage[key] = value
            },
            getItem: function(key) {
                return this._storage[key] || null
            }
        }
    }
    let _session_id_ = false,
        storageVarPrefix = 'PF_';

    if (global.localStorage.getItem(sha512(storageVarPrefix + 'session_id')) && global.localStorage.getItem(sha512(storageVarPrefix + 'session_id')) !== 'false') {
        _session_id_ = global.localStorage.getItem(sha512(storageVarPrefix + 'session_id'))
    } else {
        _session_id_ = uuid()
        global.localStorage.setItem(sha512(storageVarPrefix + 'session_id'), _session_id_)
    }

    let token = null,
        WPAPIToken = null,
        user = null,
        role = null,
        loginUserRole = null,
        host = config.apiUrl,
        api_URL = host + 'api/',
        env = 'test',
        version = 'v1',
        expires = null,
        onExpires = false,
        online = false,
        setEnv = (_env = 'production') => {
            if (window.location.hostname.indexOf('localhost') > -1) {
                env = 'dev';
                _env = 'dev';
            } else if (window.location.hostname.indexOf('test') > -1) {
                env = 'test';
                _env = 'test';
            } else if (window.location.hostname.indexOf('parentfinder.com') > -1) {
                env = 'production';
                _env = 'production';
            }

            // if (_env.toLowerCase().indexOf('prod') > -1) {
            //     env = 'production'
            //     host = config.apiUrl
            //     api_URL = host + 'api/'

            // } else if (_env.toLowerCase().indexOf('test') > -1) {
            //     env = 'test'
            //     host = config.apiUrl
            //     api_URL = host + 'api/'

            // } else if (_env.toLowerCase().indexOf('dev') > -1) {
            //     env = 'dev'
            // }
            host = config.apiUrl
            api_URL = host + 'api/'
        },
        handleErrorResponse = (xhr, ajaxOptions, thrownError) => {
            if (xhr.responseJSON) {
                if (xhr.responseJSON.message) {
                    if (xhr.responseJSON.message.results) {
                        return xhr.responseJSON.message.results.errors.map((e) => {
                            return e.code + " - " + e.message + "<br>"
                        })
                    } else if (xhr.responseJSON.message.errors) {
                        return (xhr.responseJSON.message.errors.map((e) => {
                            return e.message + "<br>"
                        }))

                    } else {
                        return xhr.responseJSON.message

                    }
                } else if (xhr.responseJSON.error && xhr.responseJSON.error.errors) {
                    return (xhr.responseJSON.error.errors.map((e) => {
                        return e.message + "<br>"
                    }))
                }
                return false
            }
            return false
        },
        toB = (str) => {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1)
                }))
        },
        fromB = (str) => {
            return decodeURIComponent(atob(str).split('').map((c) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))
        },
        logout = (forceToLogin = true) => {
            global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
            global.localStorage.setItem(sha512(storageVarPrefix + 'session_id'), false)
            global.localStorage.setItem(sha512('WPPF_session_data'), "0")
                // if (location) location.href = location.origin !== "null" ? location.origin : location.href
            $.ajax({
                method: "DELETE",
                url: host + "auth/logout",
                contentType: 'application/json',
                beforeSend: (request) => {
                    request.setRequestHeader("Authorization", "Bearer " + (token || getWPSession().token));
                },
                success: (response) => {
                    if (forceToLogin) {
                        window.getApp.$emit('APP_LOGOUT')
                    }
                },
                error: (xhr, ajaxOptions, thrownError) => {
                    window.getApp.$emit('APP_LOGOUT')
                    // window.getApp.$emit('APP_BAD_REQUEST', handleErrorResponse(xhr, ajaxOptions, thrownError))
                    // if (error) error(handleErrorResponse(xhr, ajaxOptions, thrownError))
                }
            });
        },
        login = (c) => {
            let username = c.username,
                password = sha512.hex(c.password),
                success = c.success || false,
                error = c.error || false,
                _env = c.env || env,
                payload = null;

            setEnv(_env)

            onExpires = c.onExpires || false

            if (password.length < 6) {
                if (error) error("Password need to have at least 6 chars.")
                return
            }
            let os = 'unknown';
            let browser = 'unknown';
            let device = 'unknown';
            let user_agent = window.navigator.userAgent;
            let ip = 'unknown';
            let geolocation = 'unknown';

            if (is.mac()) {
                os = 'Mac OS X'
            } else if (is.windows()) {
                os = 'Windows'
            } else if (is.linux()) {
                os = 'Linux'
            } else if (is.ios()) {
                os = 'ios'
            } else if (is.android()) {
                os = 'Android'
            } else if (is.android()) {
                os = 'Android'
            }

            if (is.chrome()) {
                browser = 'Chrome'
            } else if (is.firefox()) {
                browser = 'Firefox'
            } else if (is.ie()) {
                browser = 'Internet Explorer'
            } else if (is.edge()) {
                browser = 'Microsoft Edge'
            } else if (is.opera()) {
                browser = 'Opera'
            } else if (is.safari()) {
                browser = 'Safari'
            } else if (is.phantom()) {
                browser = 'Phantom'
            }

            if (is.desktop()) {
                device = 'Desktop'
            } else if (is.tablet()) {
                device = 'Tablet'
            } else if (is.mobile()) {
                device = 'Mobile'
            } else if (is.androidPhone()) {
                device = 'Android Phone'
            } else if (is.androidTablet()) {
                device = 'Android Tablet'
            } else if (is.blackberry()) {
                device = 'Blackberry'
            } else if (is.windowsPhone()) {
                device = 'Windows Phone'
            } else if (is.windowsTablet()) {
                device = 'Windows Tablet'
            } else if (is.ipod()) {
                device = 'Ipod'
            } else if (is.ipad()) {
                device = 'Ipad'
            } else if (is.iphone()) {
                device = 'Iphone'
            }

            _session_id_ = uuid()
            global.localStorage.setItem(sha512(storageVarPrefix + 'session_id'), _session_id_)


            payload = {
                username,
                password,
                info: {
                    session_id: _session_id_,
                    browser,
                    os,
                    device,
                    user_agent
                }
            }
            $.getJSON(config.geoPlugin.url + '?key=' + config.geoPlugin.sslKey, function(geodata) {

                payload.info.ip = geodata.query
                payload.info.geolocation = geodata.lat + ' ' + geodata.lon
                payload.info.country = geodata.country
                payload.info.city = geodata.city
                payload.info.state = geodata.regionName

                $.ajax({
                    method: "POST",
                    url: api_URL + "authentication",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(payload),
                    success: (response) => {
                        setSession(response, success)
                    },
                    error: (xhr, ajaxOptions, thrownError) => {
                        window.getApp.$emit('APP_LOGIN_FAILED', handleErrorResponse(xhr, ajaxOptions, thrownError))
                        if (error) error(handleErrorResponse(xhr, ajaxOptions, thrownError))
                    }
                });
            });
            /* axios.get(config.geoPlugin.url + '?key=' + config.geoPlugin.sslKey).then((geodata) => {

                payload.info.ip = geodata.data.query
                payload.info.geolocation = geodata.data.lat + ' ' + geodata.data.lon
                payload.info.country = geodata.data.country
                payload.info.city = geodata.data.city
                payload.info.state = geodata.data.regionName

                axios({
                    method: "post",
                    url: api_URL + "authentication",
                    contentType: 'application/json',
                    data: payload,
                }).then(response => {
                    setSession(response.data, success)
                }).catch(loginError => {
                    console.log('error', loginError)
                    window.getApp.$emit('APP_LOGIN_FAILED', loginError)
                    if (loginError) error(loginError)
                });
            }).catch((geoPluginError) => {
                console.log('Geoplugin error:', geoPluginError)
                window.getApp.$emit('APP_LOGIN_FAILED', geoPluginError)
                if (geoPluginError) error(geoPluginError)
            }); */

        },
        WPAPILogin = (c) => {
            return new Promise(async function(resolve, reject) {
                $.ajax({
                    method: c.method || 'POST',
                    url: c.url,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(c.payload),
                    success: (response) => {
                        if (response.token) {
                            response.success = true;
                            WPAPIToken = response.token;
                            global.localStorage.setItem(sha512('WPPF_session_data'), toB(JSON.stringify(response)));
                        } else {
                            window.getApp.snackbar = {
                                show: true,
                                color: 'red',
                                text: 'Failed to connect with WP API.'
                            };
                        }
                        resolve(response);
                    },
                    error: (xhr, ajaxOptions, thrownError) => {
                        window.getApp.snackbar = {
                            show: true,
                            color: 'red',
                            text: 'Failed to connect with WP API.'
                        };
                        reject(thrownError);
                    }
                });
            });
        },
        requestToWPPF = (c) => {
            return new Promise(async function(resolve, reject) {
                let response = {
                    data: null,
                    error: null
                }
                c.method = c.method || 'GET'
                c.beforeSend = (request) => {
                    request.setRequestHeader("Authorization", "Bearer " + (WPAPIToken || getWPSession().token));
                }
                c.dataType = 'json'
                c.data = JSON.stringify(c.payload)
                c.contentType = 'application/json'
                c.success = (a) => {
                    response.data = a
                    resolve(a)
                }
                c.error = (a, b, c) => {
                    let objResponse = JSON.parse(a.responseText)

                    response.error = objResponse.error ? objResponse.error : true;
                    response.message = objResponse.message ? objResponse.message : 'Something went wrong, please try again';
                    resolve(response)
                }
                $.ajax(c)
            })
        },
        _login = (c) => {
            let username = c.username,
                password = c.password,
                success = c.success || false,
                error = c.error || false,
                _env = c.env || env,
                payload = null;

            loginUserRole = c.loginUserRole || null;

            setEnv(_env)

            onExpires = c.onExpires || false

            if (password.length < 6) {
                if (error) error("Password need to have at least 6 chars.")
                return
            }
            payload = {
                username,
                password,
            }
            $.ajax({
                method: "POST",
                url: api_URL + "authentication",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(payload),
                success: (response) => {
                    setSession(response, success)
                },
                error: (xhr, ajaxOptions, thrownError) => {
                    if (error) error(handleErrorResponse(xhr, ajaxOptions, thrownError))
                }
            })
        },
        loginPromise = (c) => {
            return new Promise ((resolve, reject) => {
                try {
                    let username = c.username,
                        password = c.password,
                        _env = c.env || env,
                        payload = null;
        
                    loginUserRole = c.loginUserRole || null;
        
                    setEnv(_env)
        
                    onExpires = c.onExpires || false
                    payload = {
                        username,
                        password,
                    }
                    $.ajax({
                        method: "POST",
                        url: api_URL + "authentication",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(payload),
                        success: (response) => {
                            resolve(response);
                        },
                        error: (xhr, ajaxOptions, thrownError) => {
                            reject(thrownError);
                        }
                    })
                } catch (e) {
                    reject(e);
                }
            })
        },
        setSession = (response, success) => {
            // console.log(response)
            if (response.status) {
                delete response.status
            }
            if (response.message) {
                delete response.message
            }
            token = response.token
            user = response.user
            role = response.user.role
            expires = response.expires
            response.env = env
            response.id = _session_id_

            storageVarPrefix = 'PF_' + (loginUserRole ? loginUserRole + '_' : '');

            global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), toB(JSON.stringify(response)))

            online = true

            if (env.toLowerCase().indexOf('test') > -1 || env.toLowerCase().indexOf('prod') > -1) {
                //api_URL = response.api + '/api/' + version + '/'
            }

            checkToken()

            if (success) success(response)
            return response
        },
        getSession = () => {
            let localSession = null;
            try {
                localSession = global.localStorage.getItem(sha512(storageVarPrefix + 'session_data'))
            } catch (e) {
                localSession = false;
                global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
            }

            if (localSession === "0") {
                localSession = false
            }
            if (localSession) {
                try {
                    localSession = JSON.parse(fromB(localSession))
                } catch (e) {
                    global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
                }
            } else {
                global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0");
            }
            return localSession;
        },
        getWPSession = () => {
            let WPLocalSession = null;
            try {
                WPLocalSession = global.localStorage.getItem(sha512('WPPF_session_data'))
            } catch (e) {
                WPLocalSession = false;
                global.localStorage.setItem(sha512('WPPF_session_data'), "0")
            }

            if (WPLocalSession === "0") {
                WPLocalSession = false
            }
            if (WPLocalSession) {
                try {
                    WPLocalSession = JSON.parse(fromB(WPLocalSession))
                } catch (e) {
                    global.localStorage.setItem(sha512('WPPF_session_data'), "0")
                }
            } else {
                global.localStorage.setItem(sha512('WPPF_session_data'), "0");
            }
            return WPLocalSession;
        },
        checkTokenIterval = null,
        checkToken = () => {
            checkTokenIterval = setInterval(() => {
                let now = moment().toDate()
                if (now > moment(expires).toDate()) {
                    global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
                    online = false
                    if (onExpires) onExpires()
                    clearInterval(checkTokenIterval)
                    alert("Session expired. Please do login again.")
                        // window.getApp.$emit('APP_AUTH_FAILED')
                }
            }, 5000)
        },
        ajax = (c) => {
            // console.log('c.url', c.url)
            // console.log('api_URL + c.url', api_URL)
            c.method = c.method || 'GET'
            c.beforeSend = (request) => {
                request.setRequestHeader("Authorization", "Bearer " + token)
                    /*swal.fire({
                        title: "Data transfer",
                        text: "Performing server " + c.method    + " request",
                        type: "warning",
                        buttons: false,
                        dangerMode: true
                    })*/
            }

            const success = c.success,
                error = c.error;

            c.success = (a) => {
                /*swal.stopLoading();
                swal.close();
                swal.fire({
                    title: "Data transfer",
                    text: "Data is ready",
                    type: "success",
                    buttons: false,
                    dangerMode: true
                })

                setTimeout(() => {
                    swal.stopLoading();
                    swal.close();
                }, 1000)
                */
                success(a)
            }
            c.error = (a, b, c) => {
                /*swal.fire({
                    title: "Data transfer",
                    text: "Data is not ready",
                    type: "error",
                    buttons: false,
                    dangerMode: true
                })

                setTimeout(() => {
                    swal.stopLoading();
                    swal.close();
                }, 1000)*/

                error(a, b, c)
            }

            c.url = api_URL + c.url
            $.ajax(c)
        },
        http = (c) => {
            c = JSON.parse(JSON.stringify(c))
            let _env = c.env || env;

            setEnv(_env)
            return new Promise(async function(resolve, reject) {
                let response = {
                    data: null,
                    error: null
                }
                c.type = c.type || 'GET'
                c.beforeSend = (request) => {
                    request.setRequestHeader("Authorization", "Bearer " + (c.token || token))
                }
                c.dataType = 'json'
                c.contentType = 'application/json'
                c.success = (a) => {
                    response.data = a.data
                    resolve(a)
                }
                c.error = (a, b, c) => {
                    let errorMessage = '';
                    if (a.responseText) {
                        let objResponse = {}
                        try {
                            objResponse = JSON.parse(a.responseText || '')
                        } catch (e) {
                            // 
                        }

                        if (objResponse.error) {
                            // if (typeof objResponse.error === 'string') {
                            //     errorMessage = objResponse.error
                            // } else {
                            // swagger validation
                            if (objResponse.error.results) {
                                objResponse.error.results.errors.forEach(e => {
                                    errorMessage = errorMessage + `${e.description}: ${e.message} \n`
                                });
                            } else {
                                errorMessage = objResponse.message
                            }
                            // }
                        } else {
                            errorMessage = objResponse.message
                            response.data = a.responseText
                        }
                    } else {
                        errorMessage = 'Couldn\'t finish your request, please try refresh and try again'
                    }
                    response.error = errorMessage

                    // response.error = handleErrorResponse(a, b, c)
                    if (response.error === 'Unauthorized') {
                        logout()
                        reject(response)
                    } else {
                        if (!response.data) {
                            window.getApp.$emit('APP_BAD_REQUEST', response.error)
                        }
                        resolve(response)
                    }

                }

                c.url = api_URL + c.url
                $.ajax(c)
            })
        },
        upload = (c) => {
            let _env = c.env || env;

            setEnv(_env)
            return new Promise(async function(resolve, reject) {
                let response = {
                        data: null,
                        error: null
                    }
                    // var formData = new FormData();
                    // formData.append('fileUpload', event.target.files[0]);
                    //c.data = formData
                console.log('CDATA', c.data);
                c.type = c.type ? c.type : 'PATCH'
                c.cache = false
                c.contentType = false
                c.processData = false
                c.beforeSend = (request) => {
                        request.setRequestHeader("Authorization", "Bearer " + token)
                        request.setRequestHeader("Accept", "application/json")
                    }
                    //c.dataType = 'json'
                    //c.contentType = 'application/json'
                c.success = (a) => {
                    response.data = a.data
                    if (c.bus) {
                        c.bus.$emit('fileProgressComplete');
                    }
                    resolve(a)
                }
                c.error = (a, b, c) => {
                    let errorMessage = '';
                    let objResponse = JSON.parse(a.responseText)
                    console.log(objResponse)
                    if (objResponse.error) {
                        // swagger validation
                        if (objResponse.error.results) {
                            objResponse.error.results.errors.forEach(e => {
                                errorMessage = errorMessage + `${e.description}: ${e.message} \n`
                            });
                        } else {
                            errorMessage = objResponse.message
                        }
                    } else {
                        errorMessage = objResponse.message
                    }
                    response.error = errorMessage

                    // response.error = handleErrorResponse(a, b, c)
                    if (response.error === 'Unauthorized') {
                        logout()
                        reject(response)
                    } else {
                        window.getApp.$emit('APP_BAD_REQUEST', response.error)
                        resolve(response)
                    }
                }

                c.url = api_URL + c.url
                c.xhr = function() { // Custom XMLHttpRequest
                    let myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) { // Avalia se tem suporte a propriedade upload
                        myXhr.upload.addEventListener('progress', function(event) {
                            /* faz alguma coisa durante o progresso do upload */
                            //console.log('uploader arguments', arguments);
                            if (c.bus) {
                                c.bus.$emit('fileProgress', event);
                            }
                        }, false);
                    }
                    return myXhr;
                }
                $.ajax(c)
            })
        },
        swagger = (c) => {
            c = c || {}
            c.method = 'GET'

            let _env = c.env || env;

            setEnv(_env)


            const success = c.success,
                error = c.error;

            c.success = (a) => {
                success(a)
            }
            c.error = (a, b, c) => {
                error(a, b, c)
            }

            c.url = host + 'api-docs'
            $.ajax(c)
        },
        api = null;

    global.onload = () => {
        api.isOnline()
    }

    api = {
        login: login,
        setEnv: setEnv,
        _login: _login,
        loginPromise: loginPromise,
        token: () => {
            return token
        },
        user: () => {
            return user
        },
        role: () => {
            return role
        },
        expires: () => {
            return expires
        },
        isOnline: () => {
            // console.log( '######### isOnline : ()' )
            let localSession = global.localStorage.getItem(sha512(storageVarPrefix + 'session_data')) || false,
                now = null;
            if (localSession === "0") {
                localSession = false
            }
            if (localSession) {
                try {
                    localSession = JSON.parse(fromB(localSession))
                        // console.log( '------->>>> session localSession', localSession )
                    online = true
                } catch (e) {
                    global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
                    online = false
                }
            } else {
                global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0");
                return false
            }

            if (online) {
                // console.log( '------->>>> isOnline', localSession )
                token = localSession.token
                user = localSession.user
                role = localSession.user.role
                expires = localSession.expires
                env = localSession.env

                online = true

                if (env.toLowerCase().indexOf('test') > -1 || env.toLowerCase().indexOf('prod') > -1) {
                    //api_URL = localSession.api + '/api/' + version + '/'
                }
            } else {
                return false
            }

            now = moment().toDate()

            if (now > moment(expires).toDate()) {
                global.localStorage.setItem(sha512(storageVarPrefix + 'session_data'), "0")
                return false
            }

            if (online) {
                checkToken()
            }

            return online
        },
        ajax: ajax,
        http: http,
        upload: upload,
        swagger: swagger,
        logout: logout,
        getSession,
        getWPSession,
        setSession: setSession,
        WPAPILogin: WPAPILogin,
        requestToWPPF: requestToWPPF,
        //id: _session_id_
    }

    return api
})(window || global)


//export { session }


//window.session = session


// WEBPACK FOOTER //
// ./src/helpers/session.js